import {Button} from '@wandb/components';
import React, {useCallback, useState} from 'react';

import {trackMarimoClickRun} from '../../../../services/analytics/productEvents';
import {
  LOADING_STRINGS,
  useOnClickRunCodeButtonInSettings,
} from './useOnCreateNotebookClick';

export const RunCodeButton = ({notebookId}: {notebookId: string}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingString, setLoadingString] = useState(LOADING_STRINGS[0]);
  const onClick = useOnClickRunCodeButtonInSettings(
    notebookId,
    setIsLoading,
    setLoadingString
  );
  const onClickWithTracking = useCallback(async () => {
    trackMarimoClickRun({notebookId, source: 'panel-settings'});
    await onClick();
  }, [onClick, notebookId]);
  return (
    <Button
      variant="secondary"
      endIcon="play"
      isDisabled={isLoading}
      onClick={onClickWithTracking}>
      {isLoading ? loadingString : 'Run code'}
    </Button>
  );
};
